import script from "./FilterBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterBadge.vue?vue&type=script&setup=true&lang=js"

import "./FilterBadge.vue?vue&type=style&index=0&id=28962496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28962496"]])

export default __exports__